import styled from 'styled-components'

import PaginationComponent from '../commons/components/PaginationComponent'
import { INotification } from '../models/INotification'
import NotificationCardComponent from './NotificationCardComponent'

export type NotificationCardListComponentProps = {
    notifications: INotification[]
    onEdit: (notification: INotification) => void
    onDelete: (id: string) => void
    onUnpublish: (notification: INotification) => void
    isCardSelected: (id: string) => boolean
    handleCardSelection: (id: string) => void
    handleDownloadFile: (path: string) => Promise<void>
    currentPage: number
    totalPages: number
    onPageChange: (event: React.ChangeEvent<unknown>, page: number) => void
}

function NotificationCardListComponent({
    notifications,
    onEdit,
    onDelete,
    onUnpublish,
    isCardSelected,
    handleCardSelection,
    handleDownloadFile,
    currentPage,
    totalPages,
    onPageChange,
}: NotificationCardListComponentProps): JSX.Element {
    const renderNotifications = (): JSX.Element[] => {
        return notifications.map((notification) => (
            <CardContainer key={notification.id}>
                <NotificationCardComponent
                    notification={notification}
                    onEdit={onEdit}
                    onDelete={onDelete}
                    onUnpublish={onUnpublish}
                    isCardSelected={isCardSelected}
                    downloadFile={handleDownloadFile}
                    handleCardSelection={handleCardSelection}
                />
            </CardContainer>
        ))
    }

    return (
        <ComponentContainer>
            <CardListContainer>{renderNotifications()}</CardListContainer>
            <PaginationContainer>
                <PaginationComponent
                    numberOfPages={totalPages}
                    onChange={onPageChange}
                    currentPage={currentPage}
                />
            </PaginationContainer>
        </ComponentContainer>
    )
}

const ComponentContainer = styled.div``
const CardListContainer = styled.div``
const CardContainer = styled.div`
    padding: 13px 23px 8px 22px;
`
const PaginationContainer = styled.div`
    display: flex;
    justify-content: center;
    padding: 32px 0 32px 0;
`

export default NotificationCardListComponent
